"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTradingSessionService = void 0;
class AbstractTradingSessionService {
    // =================================================================
    // IService Properties and Methods
    // =================================================================
    dispose() {
        // This method should be implemented in derived class
    }
}
exports.AbstractTradingSessionService = AbstractTradingSessionService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWJzdHJhY3QtdHJhZGluZy1zZXNzaW9uLXNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvdHJhZGluZy1zZXNzaW9uLXNlcnZpY2UvY2xhc3Nlcy9hYnN0cmFjdC10cmFkaW5nLXNlc3Npb24tc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFzQiw2QkFBNkI7SUFDL0Msb0VBQW9FO0lBQ3BFLGtDQUFrQztJQUNsQyxvRUFBb0U7SUFFcEUsT0FBTztRQUNILHFEQUFxRDtJQUN6RCxDQUFDO0NBQ0o7QUFSRCxzRUFRQyJ9